import React from 'react';
import get from 'lodash/get';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchAdditionalData,
  setShowProductParts,
  stepToNextStage,
  validateSeatPositionData,
} from '../../Reducers/Configurator/Actions';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import AmountPriceComponent from '../../Components/AmountPrice/AmountPrice';
import { withGlobalLoader } from '@configuratorware/configurator-frontendgui/App/Reducers/UI/Actions';
import { fetchInitialConfiguration } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import AmountPriceContainer from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Containers/AmountPrice';
import { ALLSEATS, FRONTSEAT } from '../../Constants/SeatPositions';

const CustomAmountPriceContainer = (props) => {
  const dispatch = useDispatch();
  const configuratorState = useSelector((state) => state.configurator);
  const {
    showDesignView,
    configuration: {
      customdata,
      code,
      item: { identifier },
    },
  } = configuratorState;
  const isLoaded = identifier && configuratorState.selectedDesign === identifier.toUpperCase();
  let mainDesignData = false;
  const selectedSeatPostion = get(customdata, 'seatData', []).find((s) => s.identifier === 'seat_position');
  if (showDesignView && selectedSeatPostion && selectedSeatPostion.selectedAnswer === ALLSEATS) {
    const mainSeatQuestions = get(customdata, 'seatData', []).find((s) => s.identifier === FRONTSEAT);
    mainDesignData = get(mainSeatQuestions, 'questions', []).find((q) => q.identifier === 'design');
  }
  const designData = configuratorState.questions.find((ques) => ques.identifier === 'design');

  return (
    <AmountPriceContainer
      {...props}
      Component={AmountPriceComponent}
      hasLoadCode={!!code}
      isLoaded={isLoaded}
      displayAcceptDesign={true}
      selectedStage={configuratorState.selectedStage}
      // returning mainSeat when designData for currentSeat and mainSeat is available || when not ALLSEATS return designData
      designData={
        selectedSeatPostion && designData && selectedSeatPostion.selectedAnswer === ALLSEATS
          ? mainDesignData
          : designData
      }
      selectedDesign={get(configuratorState, 'selectedDesign', null)}
      stepToNextStage={() => dispatch(stepToNextStage())}
      setShowProductParts={(show) => dispatch(setShowProductParts(show))}
      showProductParts={configuratorState.showProductParts}
      loadConfiguration={async () => {
        await Services.configurator.setLoadIdentifier(configuratorState.selectedDesign);
        await dispatch(withGlobalLoader(fetchInitialConfiguration()));
        await dispatch(withGlobalLoader(fetchAdditionalData()));
      }}
      validateAnswers={() => dispatch(validateSeatPositionData())}
    />
  );
};

export default CustomAmountPriceContainer;
